import React, { useEffect, useState } from "react";
import EvenGrid from "../../stories/Forms/EvenGrid";
import SuccessModal from "../../stories/Modals/Modal";
import { useNavigate, useParams } from "react-router";
import { activationSchema } from "../../stories/Forms/validationSchema";
import { activationFields, links } from "../../stories/Forms/fields";
import Invalid from "../../stories/utils/Invalid";
import useApis from "../../services/useAPI";
import { useAuth } from "../../components/AuthContext/AuthContext";
import { activateUserUrl, checkUserUrl } from "../../utils/constants";
import logo from "../../assets/images/boots-myhealthchecked-logo.svg";
import img from "../../assets/images/notification.svg";
import LoggedInLayout from "../../stories/LoggedInScreens/LoggedInLayout";
import { XCircleFill } from "react-bootstrap-icons";
import  formatData from "../../utils/utils";

/**
 * Component for rendering the Activation page.
 * @returns {JSX.Element} - Rendered component.
 */
let user;
const Activation = () => {
  const [activationStr, setActivationStr] = useState("");
  const [error, setError] = useState();
  const [isActivation, setIsActivation] = useState(false);
  const navigate = useNavigate();

  const { id } = useParams();
  const auth = useAuth();

  const {
    callApi,
    setUrl,
    setMethod,
    serverError,
    resultGet,
    resultPost,
    modalShow,
    tokenError,
    toggleShowError,
    setModalShow,
  } = useApis(`${checkUserUrl}${id}`, "GET");
  

  useEffect(() => {
    if (serverError || tokenError) {
      auth?.showToast(
        "Error",
        tokenError || serverError,
        "../assets/mhc.png",
        {icon: <XCircleFill />},
      );
    }
  }, [serverError, tokenError]);

  // Fetch activation string on component mount or when 'id' changes
  useEffect(() => {
    auth.setTitle("My Account");
    const fetchActivationStr = async () => {
      await callApi();
    };

    fetchActivationStr();
  }, [id, auth.title]);

  // Update activation string if 'resultGet' changes
  useEffect(() => {
    auth.setTitle("My Account");

    if (resultGet) {
      user = resultGet.activation_str;
      setActivationStr(resultGet.activation_str);
    }
  }, [resultGet]);

  useEffect(() => {
    // Check for conditional rendering of LoggedInLayout.
    globalThis.location.pathname.includes("/my-account")
      ? setIsActivation(true)
      : setIsActivation(false);
  }, [isActivation]);

  // Handle form submission
  const handleSubmit = async (data) => {
    setError("");
    setUrl(activateUserUrl);
    setMethod("POST");

    const formattedData = formatData(data);

    const postData = {
      ...formattedData,
      occupation: formattedData.occupation.toLowerCase(),
      activation_string: id,
      email: user.email,
      organisation: user.organisation,
    };

    await callApi(postData, activateUserUrl, "POST");
    if (!serverError) {
      setModalShow(true);
    }
  };

  const handleRedirect = () => {
    navigate("/patient-record");
  };

  return (
    <LoggedInLayout
      buttonLabel={"Logout"}
      img={img}
      isActivation={isActivation}
      links={links}
      logo={logo}
      pageTitle={auth.title}
    >
      {!activationStr ? (
        <Invalid message={serverError} />
      ) : (
        <div className="phlebotomist-create-account">
          <p className="account-form-title">
            Enter the fields below to create account
          </p>
          <EvenGrid
            askConfirmation={true}
            data={activationStr || user}
            fields={activationFields}
            onSubmit={handleSubmit}
            serverError={serverError || error}
            validationSchema={activationSchema}
            validateOnChange={true}
          />
          {resultPost && (
            <SuccessModal
              href="/login"
              label={"Continue"}
              onHide={() => setModalShow(false)}
              redirect={handleRedirect}
              show={modalShow}
              variant={"danger"}
              close={false}
            />
          )}
        </div>
      )}
    </LoggedInLayout>
  );
};

export default Activation;
